/**
 * Created by Owner on 2016/8/6.
 * 直选复式  五星特殊
 * selectArea: {
          layout: [
            {
              title: "千位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "万位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "千位",
              no: "0|1|2|3|4|5|6|7|8|9"
            },
            {
              title: "百位",
              no: "0|1|2|3|4|5|6|7|8|9"
            }
          ],
          noBigIndex: 5,
 */
import {Component, OnInit, ViewChildren, QueryList, Input, Output, EventEmitter, ViewChild} from '@angular/core';
import {SelectMarkNum} from "../selectMarkNum/selectMarkNum";
import {LotteryMath} from "./lotteryMath";

@Component({
    selector: 'lottery-math-zxfs',
    templateUrl: 'selectMath.html',
})
export class LotteryMathZXFSComponent implements LotteryMath {
    @ViewChildren(SelectMarkNum) children: QueryList<SelectMarkNum>;
    _selectAreaOption: any;
    //任选位置信息
    defaultPosition: any = [];
    selectLayout: any = [];
    btnsOption: any = [];
    lt_position_sel: number;
    @Output() onTotal: EventEmitter<any> = new EventEmitter<any>();

    @Input()
    set selectAreaOption(selectAreaOption: any) {
        if (selectAreaOption) {
            this.selectLayout = selectAreaOption.layout;
            if (selectAreaOption.hasOwnProperty("defaultposition")) {
                let defaultposition = selectAreaOption["defaultposition"];
                this.btnsOption = [
                    {
                        text: "万",
                        type: "0",
                        isSelect: defaultposition[0] == "1"
                    },
                    {
                        text: "千",
                        type: "1",
                        isSelect: defaultposition[1] == "1"
                    },
                    {
                        text: "百",
                        type: "2",
                        isSelect: defaultposition[2] == "1"
                    },
                    {
                        text: "十",
                        type: "3",
                        isSelect: defaultposition[3] == "1"
                    },
                    {
                        text: "个",
                        type: "4",
                        isSelect: defaultposition[4] == "1"
                    }
                ];
            }
        }
        this._selectAreaOption = selectAreaOption;
    }

    get selectAreaOption() {
        return this._selectAreaOption;
    }

    initView() {
        this.children.toArray().forEach(child => {
            child.initView();
        });
    }

    positionLg() {
        this.defaultPosition = [];
        this.btnsOption.forEach(item => {
            if (item.isSelect) {
                this.defaultPosition.push(item);
            }
        });
        this.lt_position_sel = this.defaultPosition.length;
    }

    postionFn() {
        this.positionLg();
        this.changeTotal(null);
    }

    changeTotal(selectInfo: any) {
        let tmpTotal: number = 1;
        this.children.toArray().every(child => {
            if (child.selectNo.length == 0) {
                tmpTotal = 0;
                return false;
            } else {
                tmpTotal *= child.selectNo.length;
                return true;
            }
        });
        this.setTotal(tmpTotal);
    }

    setTotal(total: number | any) {
        let selectNo: any = [];
        this.children.toArray().forEach(child => {
            selectNo.push(child.selectNo);
        });
        this.onTotal.emit({
            total: total,
            defaultPosition: this.defaultPosition,
            selectNo: selectNo,
            type: 'digital'
        });
    }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/zxfs.ts